export const notificationsPageStyle = {
  wrapper: {
    background: 'var(--default-white)',
    borderRadius: '8px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'var(--box-shadow--2)',
    minHeight: 'calc(100vh - 128px)',
    height: '100%',
  },
  title: {
    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },
  description: {
    color: 'var(--neutral-300)',
    marginBottom: '24px',
  },

  tabs: {
    '.MuiTab-root': {
      width: '50%',
      maxWidth: 'initial',

      h6: {
        color: 'var(--neutral-300)',
      },

      '&:hover h6': {
        color: '3px solid var(--primary-500)',
      },
    },

    '&.MuiTabs-root .MuiTab-root.Mui-selected': {
      borderBottom: '3px solid var(--primary-500)',

      '&:hover': {
        borderBottom: '3px solid var(--primary-500)',
      },

      h6: {
        color: 'var(--primary-900)',
        paddingBottom: '-5PXpx',
      },
    },
  },

  badgeIcon: {
    '& .MuiBadge-badge': {
      backgroundColor: 'var(--error-500)',
      marginLeft: '8px',
      padding: '12px 12px',
      borderRadius: '50px',
    },
  },

  wrapperList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '24px',
    flex: 1,
  },

  group: {
    color: 'var(--neutral-300)',
    fontSize: '12px',
    marginBottom: '8px',
  },
  groupWrapper: {
    paddingLeft: '36px',
  },
  wrapperTitle: {
    height: '42px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    width: 'fit-content',
    marginLeft: 'auto',
    '&.Mui-disabled svg path': {
      stroke: 'var(--primary-200) !important',
    },
  },
  tabsWrapper: {
    marginTop: '24px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    marginBottom: '12px',

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },
};
